import { SubscriptionPeriodSetting } from "./OrderFlowTypes";
export const DEFAULT_CART = {
    omissions: [],
    currentPage: 1,
    totalPages: 1,
    isSubscription: false,
    recipeType: {
        alternaltiveRecipeTypeIds: null,
        defaultImage: "",
        description: "",
        recipeTypeId: 0,
        recipeTypeName: "",
        recipeTypePrice: 0,
        recipeTypeShortName: "",
        sequence: 0,
        isAllRecipeType: false,
    },
    mealSize: {
        CompanyId: 0,
        RecipeSizeId: 0,
        Size: "",
    },
    meals: [],
    template: [],
    products: [],
    daysOfWeek: [],
    selectedDay: "",
    cutoffDay: "",
    startDate: "",
    subscriptionPeriod: 1,
    subscriptionPeriodSetting: SubscriptionPeriodSetting.MATCH_SUBSCRIPTION_PERIOD,
    oneTimeOrderPeriod: undefined,
    dayQuantity: undefined,
    bundles: [],
    questionAnswers: [],
    sku: "",
};
